import * as React from "react";
import { Context } from "./_context";
export const CategoryPopularIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.5 3a1 1 0 0 1 .824 1.566l-4.712 6.854a6.5 6.5 0 1 1-9.225 0L2.677 4.566A1 1 0 0 1 3.5 3h17ZM12 11.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM5.4 5 9 10.233c.365-.19.751-.346 1.153-.465L13.181 5H5.4ZM15.55 5l-2.88 4.533c.834.086 1.62.33 2.33.7L18.6 5h-3.05Z", fill: "currentColor" }));
  return iconset[size];
};
CategoryPopularIcon.iconId = "J27idV";
